import React from 'react'
import AuthLayout from '../../components/Layout/AuthLayout'
import SocialButtonsPanel from '../../components/auth/SocialButtonsPanel'
import BackPanel from '../../components/auth/BackPanel'
import PasswordResetForm from '../../components/auth/Forms/PasswordResetForm'
import { useHistory } from 'react-router-dom';
import { RoutePath } from '../../types';

export default function PasswordResetPage() {
  const history = useHistory()
  return (
    <AuthLayout>
      <BackPanel text='Восстановление пароля' />
      <PasswordResetForm openPassResetModal={() => history.replace('/login')}/>
      <SocialButtonsPanel />
    </AuthLayout>
  )
}
